import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
}

export const UnsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = component => {
    return component.canDeactivate ? component.canDeactivate() : true;
};
